import React, { useEffect, useState } from "react";
import { BackHandler, Dimensions, TouchableOpacity, View } from "react-native";
import { web } from "../accessories/Platform";
import CustomText from "../accessories/CustomText";
import ExternalSourceViewer from "../accessories/ExternalSourceViewer";
import Footer from "../accessories/footer";
import FontAwesome from "react-native-vector-icons/FontAwesome";
import ArrowSpinner from "../accessories/ArrowSpinner";

const CalculatorApp = (props) => {
  let LoanId = 0;
  const { navigation, route, setFloatPage = () => {}, LoanId: pLoanId } = props;
  const { params = {} } = route;
  const { From, UserId, type, LoanId: iLoanId } = params;
  const [processingStatus, setProcessingStatus] = useState("pageLoading");
  LoanId = pLoanId || iLoanId;

  const handleBackAction = () => {
    navigation?.navigate(From || "DashBoard", params);
    setFloatPage(
      web ? { path: "CalculatorMenu", From, options: { From } } : null
    );
    return true;
  };
  useEffect(() => {
    const backHandler = BackHandler.addEventListener(
      "hardwareBackPress",
      handleBackAction
    );
    return () => backHandler.remove();
  }, []);
  const { width } = Dimensions.get("window"),
    isMobileWeb = width <= 480,
    url = __DEV__
      ? `http://localhost:3000/MortgageCalculator/index.html?type=${type}&loanId=${LoanId}&w=${parseInt(
          width
        )}&f=m&p=${web ? 0 : 1}`
      : `https://www.directmortgage.com/MortgageCalculator/index.html?type=${type}&loanId=${LoanId}&w=${parseInt(
          width
        )}&f=m&p=${web ? 0 : 1}`;
  console.log(url);

  return (
    <>
      <TouchableOpacity
        activeOpacity={1}
        // style={{ borderBottomWidth: 1, borderColor: "#d9d9d9" }}
      >
        <CustomText
          bold={true}
          style={{ paddingVertical: 10, paddingHorizontal: 10 }}
          onPress={handleBackAction}
        >
          <FontAwesome name="angle-left" size={16} /> Back
        </CustomText>
      </TouchableOpacity>
      {processingStatus === "pageLoading" && (
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <View
            style={{
              height: web ? 22 : 16,
              width: web ? 22 : 16,
            }}
          >
            <ArrowSpinner size={web ? 22 : 16} color="#376596" isSpinner />
          </View>
          <CustomText bold>{" Loading..."}</CustomText>
        </View>
      )}
      <ExternalSourceViewer
        url={url}
        onLoad={() => {
          setProcessingStatus("frameLoaded");
        }}
        isNeedBack={false}
      />
      {(!web || isMobileWeb) && (
        <Footer
          iLoanId={LoanId}
          navigate={navigation?.navigate}
          From={From}
          UserId={UserId}
          setFloatPage={setFloatPage}
        />
      )}
    </>
  );
};

export default CalculatorApp;
